module.exports = __webpack_public_path__ + "static/media/redBalloon.37ec8dfd.svg";